module.exports = __webpack_public_path__ + "a5f19c4821f831baec34465c9cf4f490.pdf";